export { default } from './BeansBlock';
